import { create } from "zustand";

interface InsufficientBalanceState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useInsufficientBalanceStore = create<InsufficientBalanceState>(
  (set) => ({
    isOpen: false,
    open: () => { set({ isOpen: true }); },
    close: () => { set({ isOpen: false }); },
  }),
);
